import { render, staticRenderFns } from "./ValeVistaSNTDRPolicy.vue?vue&type=template&id=3c4c3a60&scoped=true&"
import script from "./ValeVistaSNTDRPolicy.vue?vue&type=script&lang=js&"
export * from "./ValeVistaSNTDRPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ValeVistaSNTDRPolicy.vue?vue&type=style&index=0&id=3c4c3a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c3a60",
  null
  
)

export default component.exports